import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function KeyboardDoubleArrowRightIcon(props: IconProps) {
    return <Icon {...props} iconKey={"keyboard_double_arrow_right"}/>
}
